import styled from 'styled-components';

export const AudioContainer = styled.div`
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  border: 1px solid rgba(238, 241, 240, 1);
`;

export const PlayPauseButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  outline: none;
  margin-right: 16px;
`;

export const ProgressBar = styled.input`
  width: 242px;
  margin: 0 10px;
  appearance: none;
  height: 4px;
  border-radius: 4px;
  cursor: pointer;
  background: ${({ value }) => 
    `linear-gradient(to right, #0a033c ${value}%, #ddd ${value}%)`};

  &::-webkit-slider-thumb {
    appearance: none;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #0a033c;
  }
`;

export const StyledButton = styled.button`
  width: 130px;
  height: 56px;
  margin-top: 16px;
  background-color: rgba(244, 245, 247, 1);
  border: 1.5px solid rgba(229, 233, 242, 1);
  border-radius: 8px;
  color: #0A033C;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  outline: none;

  &:hover {
    background-color: rgba(229, 233, 242, 1);
  }
`;